<template>
  <div class="side-box__row d-flex mt-3">
    <span class="side-box__content__label">{{ $t("HEADERS") }}</span>
    <div class="d-flex flex-column ml-3" style="gap: 15px">
      <div
        v-for="(row, index) in rows"
        :key="row.id"
        class="side-box__row d-flex align-items-center justify-content-end"
        style="gap: 15px"
      >
        <FormInput
          :label="index === 0 ? $t('TITLE') : ''"
          :value="row.title"
          :maxlength="100"
          @change="updateRow(index, 'title', $event)"
        />
        <div class="d-flex align-items-center">
          <FormInput
            class="mr-2"
            :label="index === 0 ? $t('VALUE') : ''"
            :value="row.value"
            :maxlength="1000"
            @change="updateRow(index, 'value', $event)"
          />
          <div :class="index === 0 ? 'mt-4' : 'mt-1'" class="pointer" @click="removeRow(index)">
            <img src="@/assets/icons/actions/ico-ico-delete-gray.svg" />
          </div>
        </div>
      </div>
      <div class="side-box__row d-flex align-items-center">
        <div class="mb-2">
          <a class="pointer" @click="addRow">{{ $t("ADD_ATTRIBUTE") }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from "@/components/forms/FormInput.vue"

export default {
  name: "EndpointHeadersField",
  components: { FormInput },
  props: {
    headers: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["update", "changed"],
  data() {
    return {
      rows: [],
      nextId: 0
    }
  },
  watch: {
    headers: {
      handler(newValue) {
        // Skip re-sync when the change originates from our own emit — comparing
        // against what our current rows produce keeps in-progress (blank) rows.
        if (JSON.stringify(newValue || {}) === JSON.stringify(this.buildHeaders())) {
          return
        }
        this.syncRowsFromHeaders(newValue)
      },
      deep: true
    }
  },
  created() {
    this.syncRowsFromHeaders(this.headers)
  },
  methods: {
    syncRowsFromHeaders(headers) {
      this.rows = Object.entries(headers || {}).map(([title, value], index) => ({
        title,
        value: value == null ? "" : String(value),
        id: index
      }))
      this.nextId = this.rows.length
    },
    buildHeaders() {
      const result = {}
      for (const row of this.rows) {
        const title = (row.title || "").trim()
        if (!title) {
          continue
        }
        result[title] = row.value ?? ""
      }
      return result
    },
    emitChange() {
      this.$emit("update", this.buildHeaders())
      this.$emit("changed")
    },
    updateRow(index, field, value) {
      this.rows = this.rows.map((row, i) => (i === index ? { ...row, [field]: value } : row))
      this.emitChange()
    },
    addRow() {
      this.rows = [...this.rows, { title: "", value: "", id: this.nextId++ }]
      this.$emit("changed")
    },
    removeRow(index) {
      this.rows = this.rows.filter((_, i) => i !== index)
      this.emitChange()
    }
  }
}
</script>
